module.exports = __webpack_public_path__ + "static/media/logo-renner.d8b94088.png";